import { render, staticRenderFns } from "./StartGray.vue?vue&type=template&id=049adb30"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049adb30')) {
      api.createRecord('049adb30', component.options)
    } else {
      api.reload('049adb30', component.options)
    }
    module.hot.accept("./StartGray.vue?vue&type=template&id=049adb30", function () {
      api.rerender('049adb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/StartGray.vue"
export default component.exports